export enum DocumentTypeEncryptionEnabledType {
  Disabled = 0,
  EnabledForNewDocuments,
  EnabledForNewAndExistingDocuments
}